var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 273,
    viewBox: "0 0 272 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.553 91.408H10.835V123.141H264.553V91.408Z",
    fill: "#B0B6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6575 157.536L32.4853 162.381L29.3379 161.616L31.9672 150.73L33.6575 157.536Z",
    fill: "#23293F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1432 127.066H42.808L60.5916 200.856H50.3204L32.5432 127.066H29.208L47.7688 204.094H64.704L46.1432 127.066Z",
    fill: "#23293F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0159 160.237L22.4727 204.094H5.54395L24.1047 127.066H27.4335L9.65633 200.856H19.9211L29.3569 161.623L29.8685 159.479L33.003 160.237H33.0159Z",
    fill: "#23293F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.419 157.536L233.247 162.381L230.1 161.616L232.729 150.73L234.419 157.536Z",
    fill: "#23293F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.905 127.066H243.57L261.353 200.856H251.082L233.305 127.066H229.97L248.53 204.094H265.466L246.905 127.066Z",
    fill: "#23293F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 160.237L223.234 204.094H206.306L224.866 127.066H228.195L210.418 200.856H220.683L230.119 161.623L230.63 159.479L233.765 160.237H233.778Z",
    fill: "#23293F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.34 213.484H135.851V211.865C135.851 205.201 130.431 199.781 123.767 199.781C117.103 199.781 111.682 205.201 111.682 211.865V213.484H94.9219V210.246H108.528C109.338 202.552 115.866 196.542 123.767 196.542C131.668 196.542 138.189 202.552 139.005 210.246H152.346V213.484H152.34Z",
    fill: "#23293F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.13 175.922H168.828V174.303C168.828 169.258 164.722 165.159 159.684 165.159C154.645 165.159 150.539 169.265 150.539 174.303V175.922H137.023V172.684H147.405C148.201 166.616 153.402 161.921 159.684 161.921C165.966 161.921 171.166 166.622 171.962 172.684H182.137V175.922H182.13Z",
    fill: "#23293F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.863 183.046H77.9346V186.284H111.863V183.046Z",
    fill: "#23293F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.464 193.408H172.416V196.646H193.464V193.408Z",
    fill: "#23293F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2441 229.675H24.4281V228.056C24.4281 225.2 22.1031 222.875 19.2471 222.875C16.3911 222.875 14.0662 225.2 14.0662 228.056V229.675H6.32715V226.436H10.9835C11.7412 222.564 15.1607 219.636 19.2471 219.636C23.3336 219.636 26.7531 222.564 27.5108 226.436H42.2441V229.675Z",
    fill: "#23293F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.673 229.675H253.401V228.056C253.401 225.2 251.076 222.875 248.22 222.875C245.364 222.875 243.039 225.2 243.039 228.056V229.675H225.223V226.436H239.956C240.714 222.564 244.133 219.636 248.22 219.636C252.306 219.636 255.726 222.564 256.483 226.436H265.673V229.675Z",
    fill: "#23293F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.039 77.9245H96.3983C88.1282 77.9245 78.265 75.3664 78.265 63.1717V58.8845L69.3926 59.7717L79.2429 45.4399L79.3335 45.4982C80.8295 43.8986 82.8436 42.9855 85.0326 42.9142C87.2798 42.843 89.4688 43.7108 91.049 45.2975L91.1914 45.4658L114.039 77.918V77.9245ZM80.8554 56.022V63.1717C80.8554 71.3512 85.9392 75.334 96.3983 75.334H109.046L89.1385 47.0655C88.0505 46.0163 86.6257 45.4723 85.1103 45.5112C83.5625 45.5565 82.1377 46.23 81.108 47.3957L81.0691 47.3569L74.6901 56.6373L80.8554 56.022Z",
    fill: "#23293F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5181 51.9096C85.9909 51.2231 85.816 50.284 85.1295 49.8113C84.4431 49.3385 83.504 49.5134 83.0312 50.1998",
    fill: "#23293F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.183 77.8858L96.6445 67.1223L97.2144 63.677L106.359 76.312L104.183 77.8858Z",
    fill: "#23293F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2047 75.9946H88.6143V89.7889H91.2047V75.9946Z",
    fill: "#23293F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9655 79.2585H95.375V89.7823H97.9655V79.2585Z",
    fill: "#23293F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1961 91.408L34.1748 123.083H50.2681L59.5291 91.408H43.1961Z",
    fill: "#F4F5F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9393 91.408L76.918 123.083H93.0113L102.272 91.408H85.9393Z",
    fill: "#F4F5F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M128.681 91.408L119.66 123.083H135.753L145.014 91.408H128.681Z",
    fill: "#F4F5F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.72 91.408L163.698 123.083H179.792L189.053 91.408H172.72Z",
    fill: "#F4F5F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 91.408L210.327 123.083H226.42L235.681 91.408H219.348Z",
    fill: "#F4F5F7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M265.025 124.76H9.21582V89.7891H265.025V100.378H261.787V93.0272H12.4539V121.522H261.787V107.275H265.025V124.76Z",
    fill: "#23293F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/error403.b1e9d769503eb69b372648528090aafd.svg";
export { ForwardRef as ReactComponent };